export default "__VITE_ASSET__X56k7V86__"